import React, { useEffect, useState } from 'react';
import ActionButton from '~components/atoms/ActionButton';
import Image from '~components/atoms/Image';
import Table from '~components/molecules/Table';
import ViewSerialNoModalModal from '~components/molecules/ViewSerialNoModal';
import UtilFunctions from '~utils/functions';

import combinedActions from '~redux/combinedActions';
import { useAppDispatch, useAppSelector } from '~redux/hooks';
import { FundTypeEnum } from '~utils/enums';

const InventoryReceivedTable = () => {
    const dispatch = useAppDispatch();

    const {
        Misc: {
            dateTimeFormat,
        },
    } = UtilFunctions;

    const isLoading = useAppSelector(state => state.gold.loadings.getGoldInventoryReportReceivedListing);
    const inventoryReceivedListingIndex = useAppSelector(state => state.gold.goldInventoryReport.inventoryReceived.index);
    const inventoryReceivedListing = useAppSelector(state => state.gold.goldInventoryReport.inventoryReceived.data);

    const [serialNoList, setSerialNoList] = useState<string[]>([]);
    const [isSerialNoModalOpen, setIsSerialNoModalOpen] = useState(false);

    useEffect(() => {
        dispatch(combinedActions.goldGetGoldInventoryReportReceivedListingAttempt());
    }, [inventoryReceivedListingIndex]);

    const tableHeader = [
        'IMAGE',
        'PRODUCT NAME',
        'RECEIVED FROM',
        'SERIAL NUMBER',
        'QUANTITY',
        'TOTAL GOLD WEIGHT (g)',
        'FUND TYPE',
        'RECEIVED AT',
    ];

    const tableBody = inventoryReceivedListing.map(inventory => {
        const {
            transferId,
            product,
            from,
            serialNumbers,
            quantity,
            fundType,
            totalGoldWeight,
            createdAt,
        } = inventory;

        const massagedSerialNumbers = serialNumbers.map(serial => serial.serialNo).filter(item => item);

        const handleViewSerialNo = () => {
            setIsSerialNoModalOpen(true);
            setSerialNoList(massagedSerialNumbers);
        };

        const renderSerialNo = () => (
            <ActionButton
                key={transferId}
                label='View'
                onClick={() => handleViewSerialNo()}
            />
        );

        return [
            <Image
                key={transferId}
                src={product.image || ''}
                width={40}
                height={40}
            />,
            product.productName,
            from.branchName,
            renderSerialNo(),
            quantity,
            totalGoldWeight,
            FundTypeEnum[fundType],
            dateTimeFormat(createdAt),
        ];
    });

    return (
        <>
            <Table
                isLoading={isLoading}
                header={tableHeader}
                body={tableBody}
            />

            <ViewSerialNoModalModal
                isOpen={isSerialNoModalOpen}
                onClose={() => setIsSerialNoModalOpen(false)}
                serialNo={serialNoList}
            />
        </>
    );
};

export default InventoryReceivedTable;
